export default "__VITE_ASSET__CRinXFT___"